<template>
  <div class="p-4 bg-white rounded-lg h-100">
    <ReportCharts
      :urls="urls"
      :mandatory-filter="[
        {
          name: 'report_date_month_range',
          title: 'Date range',
          valueFieldName: '.select',
        },
        {
          name: 'report_orders_time',
          title: 'Reports orders time',
          valueFieldName: '',
        },
      ]"
    ></ReportCharts>
  </div>
</template>

<script>
import ReportCharts from "@/own/components/reports/ReportCharts";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
export default {
  name: "ReportMonthlyAverageOrders",
  data: () => ({
    urls: {
      data_url: "/reports/reportMonthlyAverageOrders",
      show_url: "/reports/reportMonthlyAverageOrders/show",
    },
  }),
  components: { ReportCharts },

  beforeMount() {
    this.$store.commit(SET_PAGE_LOADING, true);
  },
};
</script>
